// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.57-0-ga24d0f4",
    "hash": "ga24d0f4",
    "distance": 0,
    "tag": "v1.0.57",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.57",
        "major": 1,
        "minor": 0,
        "patch": 57,
        "prerelease": [],
        "build": [],
        "version": "1.0.57"
    },
    "suffix": "0-ga24d0f4",
    "semverString": "1.0.57",
    "version": "1.0.57"
};
